import { render, staticRenderFns } from "./CampaignMemberDetail.vue?vue&type=template&id=5ccdc37c"
import script from "./CampaignMemberDetail.vue?vue&type=script&lang=js"
export * from "./CampaignMemberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports